window.DiscussCancelConfirmation = (function () {
    window.dataLayer = window.dataLayer || [];

    let self = {
        urls: {
            redirectUrl: '/my-health-insurance/manage-my-plan',
            removeDiscussPolicyCancelSession: '/api/sitecore/PolicyCancellation/RemoveDiscussPolicyCancelSession'
        },
        func: {
            init: function () {
                self.func.bindings();
            },
            bindings: function () {
                const previousPageUrl = document.referrer;
                const url = window.location.href;
                if (url.includes('/request-submitted') && !previousPageUrl.includes('/discuss-cancellation')) {
                    window.location.href = self.urls.errorPageUrl;
                }
                $('#discuss-cancel-confirm-button').on('click', self.func.removeSessionAndRedirect);
            },
            removeSessionAndRedirect: function () {
                $.post(self.urls.removeDiscussPolicyCancelSession)
                    .done(function () {
                        window.location.href = self.urls.redirectUrl;
                    });
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('discuss-cancel-confirm-section' === $('#discuss-cancel-confirm-section').data('feature')) {
        window.DiscussCancelConfirmation.Init();
    }
});
